<template>
  
   <main>
    <van-nav-bar title="数电登录"  />
 
    <van-cell-group inset>
      <!-- 搭配使用 选择 需要登录的长啊 -->
      <van-cell  title="纳税人名称" v-model="form.nsrmc" />
      <van-cell title="税号" v-model="form.nsrsbh" />
      <van-cell title="开票人" v-model="form.kpr" />
      <van-cell title="手机号" v-model="form.sjh" />
    </van-cell-group>

    <div style="margin-top: 50px; margin-left: 15px;">
      <van-button round @click="login()" style="margin-right: 30px;" type="info">数电登录</van-button>
      <van-button round @click="getewm()"  style="margin-right: 30px;" type="info">生成二维码</van-button>
      <van-button round @click="getsljg()" type="info">获取扫脸结果</van-button>
    </div>
          <van-dialog v-model="codeDialogVisible" title="请使用税局App扫码" @confirm="ssConfirm">
            <div id="qrcode" ref="qrcode" v-if="codeDialogVisible" style="margin:54px;"></div>
            <div id="countDown" class="countDown"  v-if="codeDialogVisible"></div>
          </van-dialog>
   </main>
</template>
<script>
import QRCode from 'qrcodejs2';
import { MessageBox,Indicator} from 'mint-ui';
import {
  Button,
  Calendar,
  Card,
  Checkbox,
  CheckboxGroup,
  Col,
  Dialog,
  Divider,
  Field,
  List,
  NavBar,
  Panel,
  Popup,
  Row,
  SubmitBar,
  Tab,
  Tabbar,
  TabbarItem,
  Tabs,
  Toast
} from "vant";

export default {

  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Card.name]: Card,
    [Checkbox.name]: Checkbox,
    [SubmitBar.name]: SubmitBar,
    [CheckboxGroup.name]: CheckboxGroup,
    [NavBar.name]: NavBar,
    [Tab.name]: Tab,
    [Tabbar.name]: Tabbar,
    [Tabs.name]: Tabs,
    [TabbarItem.name]: TabbarItem,
    [Panel.name]: Panel,
    [List.name]: List,
    [Button.name]: Button,
    [Field.name]:Field,
    [Dialog.Component.name]: Dialog.Component,
    [Divider.name]: Divider,
    [Popup.name]:Popup,
    [Calendar.name]:Calendar
  },

    data(){
        return {
          codeDialogVisible:false,
          countDownInterval:null,
          sms:"",
          rzid:"",
          form:{
                nsrsbh: "2350800490760490B",
                kpr: "",
                sjh: "",
                nsrmc: "龙岩市环境卫生中心",
          }

        }
    },
 created() {
  
  this.form.sjh=localStorage.getItem("sanitationUsername");
  this.form.kpr=localStorage.getItem("memName");

},
    methods: {

      ssConfirm(){


        clearInterval( this.countDownInterval);

      }, 
    login(){   //数电登录 

        let self=this;
        this.$axios
          .get("/memberBusiness/qdLogin/validateLogon")
          .then((data) => {
            if (data.code === 200) {   
                console.log('登录成功');
                // 创建弹出输入框
                MessageBox.prompt('请输入验证码').then(data => {
                  // 点击确认按钮时，会返回输入的数据
                  self.loginBysms(data.value);

                }).catch(err => {
                  // 点击取消按钮时，会捕获到错误
                  console.log(err);
                });

            } else {
              Toast(data.message);
            }
          });
           
    },

    loginBysms(sms){
      var ajaxjUrl='/memberBusiness/qdLogin/'+sms+'/validateLogonBySms';
      this.$axios
          .get(ajaxjUrl)
          .then((data) => {
            if (data.code === 200) {   
                Toast('登录成功');
            } else {
              Toast(data.message);
            }
          });
    },
    getewm(){  //获取二维码

      var ajaxjUrl='/memberBusiness/qdLogin/queryFaceRecognitionCode';
      this.$axios
          .get(ajaxjUrl)
          .then((data) => {
            if (data.code === 200) {   

              Indicator.open({
                text: "加载中...",
                spinnerType: "fading-circle"
              });
              this.viewCode();   //延时刷新
            } else {
              Toast(data.message);
            }
          });

    },
    viewCode(){   //查看二维码

      var retrunMsg="";
      var times = 1000 * 6;
		    var i=0;
            let self=this;
            var myVar = setInterval(function () {
                    ++i;
                    console.log(i);
                    if(i*1<=6){
                      var ajaxjUrl='/memberBusiness/qdLogin/viewQrcode';
                    self.$axios
                        .get(ajaxjUrl)
                        .then((data) => {
                            if (data.code === 200) {

                            self.codeDialogVisible = true;
                            setTimeout(() => {
                                document.getElementById('qrcode').innerHTML = '';
                                var ewm=data.data.ewminfo; //二维码信息
                                var rzid=data.data.rzid;//认证ID
                                var  countDown=data.data.countDown;  //倒计时
                                self.rzid=rzid;
                                console.log("rzid",rzid);
                                let qrcode = new QRCode('qrcode', {
                                    width: 200,
                                    height: 200,
                                    text: ewm // 二维码地址
                                });

                               document.getElementById('countDown').innerHTML = "二维码有效倒计时: " + countDown + " 秒";
                                 self.countDownInterval = setInterval(function () {
                                    console.log("当前剩余秒数: ", countDown)
                                    countDown--;
                                document.getElementById('countDown').innerHTML = "二维码有效倒计时: " + countDown + " 秒";
                                    if(countDown <= 0){
                                        clearInterval( self.countDownInterval);
                                    }
                                }, 1000); // 1秒执行一次
                              //去取二维码扫描结果
                              
                        }, 50);
                                  Indicator.close();  //关闭loading
                                  clearInterval(myVar);   //关闭之前的
                              
                            } else{

                              retrunMsg=data.data.message;
                            }
                        })
                        .catch(
                            function (response) {
                                console.log(response);
                                Indicator.close();
                              
                            }.bind(this)
                        );
                               
                    }else{
                        clearInterval(myVar);
                        alert('获取失败请重新获取');
                        Indicator.close();
                    }
				}, times);

    },
    getsljg(){  //查看二维码结果  


      Indicator.open({
                text: "加载中...",
                spinnerType: "fading-circle"
              });

      var self=this;
         var times = 1000 * 6;
		    var i=0;
            var myVar = setInterval(function () {
                ++i;
               console.log('查询结果'+i);
              
                   if(i*1<=8){
                    var ajaxjUrl='/memberBusiness/qdLogin/'+self.rzid+'/queryFaceRecognitionResult';
                    console.log(ajaxjUrl);
                    self.$axios
                        .get(ajaxjUrl)
                        .then((data) => {
                            if (data.data.code=='200') {
                                  self.$message({
                                    type: 'success',
                                    message: '扫码成功!'
                                });
                                Indicator.close();
                                clearInterval(myVar);    
                            } 
                        })
                        .catch(
                            function (response) {
                                //Toast.error('操作失败请重试');
                                clearInterval(myVar);
                                Indicator.close();

                            }.bind(self) 
                        );
                   }else {

                       clearInterval(myVar);
                        alert('未扫码成功');
                       Indicator.close();

                     }

	              }, times);

    }

  } 

}
</script>

<style>

.countDown{

text-align: center;
margin-top: 9px;

}

</style>